import { createSelector } from 'reselect';

import { ValueOf } from '../../globalTypes';
import { CONFIGURATION_DEVICE_TYPES, CONFIGURATION_TEST_TYPES } from '../../constants';
import * as globalSelector from '../../selectors';
import { selectors as testConfigurationSelectors } from '../testConfiguration';
import { records as realDeviceSelectionRecords } from '../realDeviceSelection';

const toolbarButtonSelector = createSelector([
  testConfigurationSelectors.deviceTypeSelector,
  testConfigurationSelectors.testTypeSelector,
  globalSelector.mobileSessionSelector,
],
(deviceType, testType, mobileSession) => {
  const { device, deviceDescriptor, deviceToolsDisabled } = mobileSession;

  return {
    device,
    deviceDescriptor,
    deviceToolsDisabled,
    deviceType,
    testType,
  } as {
    device: any; // eslint-disable-line @typescript-eslint/no-explicit-any
    deviceDescriptor: realDeviceSelectionRecords.DeviceDescriptor;
    deviceToolsDisabled: boolean;
    deviceType: ValueOf<typeof CONFIGURATION_DEVICE_TYPES>;
    testType: ValueOf<typeof CONFIGURATION_TEST_TYPES>;
  };
});

export default {
  toolbarButtonSelector,
};
